import { formatCompletedTime } from "../../intelligence/intelligenceLabels";
import SourceHealthBadge from "../SourceHealthBadge";

function mapRunStatusForBadge(status) {
  if (!status) {
    return "unknown";
  }

  return String(status).toLowerCase();
}

const AutomotiveRunsModal = ({
  source,
  runs,
  isOpen,
  isLoading,
  errorMessage,
  emptyMessage = "No ingestion runs recorded yet.",
  onClose,
}) => {
  if (!isOpen || !source) {
    return null;
  }

  return (
    <div className="admin-re-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="admin-re-modal panel-card admin-re-modal--wide"
        role="dialog"
        aria-labelledby="automotive-runs-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="admin-re-modal-header">
          <div>
            <p className="eyebrow">Vehicle Market · Production runs</p>
            <h2 id="automotive-runs-modal-title">{source.sourceName}</h2>
            <p className="muted admin-re-source-code">{source.sourceCode}</p>
          </div>
          <button type="button" className="midpoint-share-button" onClick={onClose}>
            Close
          </button>
        </header>

        <div className="admin-re-modal-body">
          {isLoading ? <p className="muted">Loading run history…</p> : null}
          {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}

          {!isLoading && !errorMessage && !runs?.length ? (
            <p className="muted">{emptyMessage}</p>
          ) : null}

          {!isLoading && runs?.length ? (
            <div className="admin-data-health-table-wrap">
              <table className="admin-data-health-table admin-re-runs-table">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Trigger</th>
                    <th>Started</th>
                    <th>Finished</th>
                    <th>Fetched</th>
                    <th>Upserted</th>
                    <th>Duration</th>
                    <th>Skipped</th>
                    <th>Removed</th>
                    <th>Error</th>
                  </tr>
                </thead>
                <tbody>
                  {runs.map((run) => (
                    <tr key={run.id}>
                      <td>
                        <SourceHealthBadge status={mapRunStatusForBadge(run.status)} />
                      </td>
                      <td>{run.triggeredBy || "—"}</td>
                      <td>{formatCompletedTime(run.startedAt)}</td>
                      <td>{formatCompletedTime(run.finishedAt)}</td>
                      <td>{run.recordsFetched ?? 0}</td>
                      <td>{run.recordsInserted ?? 0}</td>
                      <td>{run.durationLabel || (run.durationMs != null ? `${Math.round(run.durationMs / 1000)}s` : "—")}</td>
                      <td>{run.skippedCount ?? run.recordsSkipped ?? 0}</td>
                      <td>{run.summary?.listingsRemoved ?? 0}</td>
                      <td className="admin-re-error-cell">{run.errorMessage || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AutomotiveRunsModal;
